import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosCamionesEnTransito } from '../actions/TablaCamionesEnTransitoActions'
import { ListadoCamionesEnTransitoDetalleView } from '../components/ListadoCamionesEnTransitoDetalleView'
import UltimaActualizacionData from '../../../../Utils/containers/UltimaActualizacionDatos'

function ListadoCamionesEnTransitoDetalle (props) {
  const { actualizarDatosCamionesEnTransito, filtroInicial = null, actualizacionConsumidos } = props
  const [ultimaActualizacion, setUltimaActualizacion] = useState(actualizacionConsumidos)

  useEffect(() => {
    setUltimaActualizacion(actualizacionConsumidos)
  }, [actualizacionConsumidos, setUltimaActualizacion])

  useEffect(() => {
    actualizarDatosCamionesEnTransito(filtroInicial)
  }, [actualizarDatosCamionesEnTransito, filtroInicial])

  const actualizar = () => {
    actualizarDatosCamionesEnTransito(filtroInicial)
  }

  return (
    <>
      <UltimaActualizacionData
        actualizar={actualizar}
        ultimaActualizacion={ultimaActualizacion}
        setUltimaActualizacion={setUltimaActualizacion}
      />
      <ListadoCamionesEnTransitoDetalleView />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosCamionesEnTransito
}

const mapStateToProps = (state) => ({
  actualizacionConsumidos: state.dashboard.actualizacionConsumidos
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(ListadoCamionesEnTransitoDetalle)
